import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import * as _ from "lodash";
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
    selector: 'app-sales-target-setup',
    templateUrl: './sales-target-setup.component.html',
    styleUrls: ['./sales-target-setup.component.scss']
})
export class SalesTargetSetupComponent implements OnInit {
    filterValue: string = ''
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
        "salesUserName",
        "providerName",
        "action"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    constructor(private ServiceProviderService: ServiceProviderService,
        private navigationService: NavigationService    ) { }

    ngOnInit() {
        this.getTableData('');
    }

    getTableData(data) {
        if (data) {
            data = { managesalesrepCodeName: data }
        }
        this.ServiceProviderService.getManageSalesTarget(data).subscribe((result) => {
            this.data = [];
            this.data = result;
            this.data = _.orderBy(this.data, ["priority"]);
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    gotoSalesTargetHC(id,type) {
        this.navigationService.gotoSalesTargetHC(id,type);
    }
}
